<div
  *ngIf="initials"
  id="profile-circle"
  [ngStyle]="{
    height: 2.2 * size + 'em',
    width: 2.2 * size + 'em',
    backgroundColor: iconColor
  }"
  class="d-flex justify-content-center align-items-center p-1 {{ iconColor }}"
>
  <span [ngStyle]="{ fontSize: 1 * size + 'em' }" id="initial-1">{{
    initials.first
  }}</span>
  <span [ngStyle]="{ fontSize: 1 * size + 'em' }" id="initial-2">{{
    initials.last
  }}</span>
</div>
